"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";
import { Heading } from "@/components/ui/typography";

import type { JSX } from "react";

const faqItems = [
  {
    value: "item-1",
    question: '"Can a non-US citizen legally own a US LLC?"',
    answer: (
      <>
        <span className="font-bold text-white">Yes.</span>
        <span className="text-white/70">
          {" "}
          100% legal. The US has zero restrictions on foreign LLC ownership. You
          don&apos;t need to be a citizen, you don&apos;t need a visa, and you
          don&apos;t need to set foot in the US. Delaware and Wyoming both
          welcome international founders. We handle the entire process remotely.
        </span>
      </>
    ),
  },
  {
    value: "item-2",
    question: '"What\'s the difference between an EIN and an ITIN?"',
  },
  {
    value: "item-3",
    question: '"What if my bank application gets rejected?"',
  },
  {
    value: "item-4",
    question: '"How much does the full US LLC FastTrack package cost?"',
  },
  {
    value: "item-5",
    question: '"How do you get the EIN so fast? Others say 4–6 weeks."',
  },
  {
    value: "item-6",
    question: '"Why a Florida address? Why not Delaware or Wyoming?"',
  },
  {
    value: "item-7",
    question: '"Do I need to pay US taxes?"',
  },
  {
    value: "item-8",
    question:
      '"Already have a US LLC — can you help with banking and processing?"',
  },
];

export const FounderFaqSection = (): JSX.Element => {
  return (
    <section className="relative w-full bg-black px-4 py-[70px] sm:px-6 xl:px-[120px]">
      <Card className="w-full rounded-2xl border border-white/10 bg-[#0f1218] shadow-none">
        <CardContent className="flex flex-col items-center gap-10 p-6 sm:p-10 lg:gap-16 lg:p-12">
          <header className="w-full">
            <Heading as="h2" variant="sectionCentered">
              Questions You&apos;re Probably
              <br />
              Asking Right Now
            </Heading>
          </header>
          <Accordion
            type="single"
            collapsible
            defaultValue="item-1"
            className="flex w-full flex-col gap-0"
          >
            {faqItems.map((item, index) => {
              const isOpen = index === 0;

              return (
                <AccordionItem
                  key={item.value}
                  value={item.value}
                  className={
                    isOpen
                      ? "overflow-hidden rounded-xl border border-white/10 bg-white/5 px-4 py-4 sm:px-8 sm:py-[26px]"
                      : "border-b border-white/10 bg-transparent px-4 py-4 sm:px-8 sm:py-[26px]"
                  }
                >
                  <AccordionTrigger className="py-0 text-left hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0 sm:[&>svg]:h-6 sm:[&>svg]:w-6">
                    <span className="font-inter text-base font-semibold leading-[1.3] tracking-[-0.24px] text-white sm:text-2xl sm:leading-[33.6px] lg:leading-9">
                      {item.question}
                    </span>
                  </AccordionTrigger>
                  {item.answer ? (
                    <AccordionContent className="pt-4 pb-0 sm:pt-6">
                      <p className="font-inter text-sm font-normal leading-[1.6] tracking-[0] text-white/70 sm:text-lg sm:leading-[28.8px]">
                        {item.answer}
                      </p>
                    </AccordionContent>
                  ) : null}
                </AccordionItem>
              );
            })}
          </Accordion>
        </CardContent>
      </Card>
    </section>
  );
};
